import template from "./pD365PgConfig.html";

export function pD365PgConfigDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pD365PgConfigController,
    controllerAs: 'pD365PgConfig',
    bindToController: true
  };

  return directive;
}

class pD365PgConfigController {
  constructor($scope, $location, $interval, $q, Auth, D365, Notes, Sort, Utils, bModal) {
    'ngInject';
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.$q = $q;
    this.Auth = Auth;
    this.D365 = D365;
    this.Notes = Notes;
    this.Sort = Sort;
    this.Utils = Utils;
    this.bModal = bModal;
    this.state = "loading";
    this.addExceptionModal = false;
    this.newExceptionPG = null;
    this.processesToChoose = null;
    this.newExceptionProcess = null;
    this.newExceptionJobCode = null;

    this.headers = [
      {name: "CASEMAN.PROCESS_GROUP_KLIX", class: "table-info"},
      {name: "CASEMAN.JOBCODE_CASEMAN", class: "table-caseman"},
    ];

    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        //Notes...
        const timeout = this.$interval(() => { this.notes = this.Notes.getNotes();}, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        this.getData();
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  getData() {
    this.D365.getPGMappers().then(
      (success) => {
        this.processGroupsKlix = success.data.processGroups.sort(this.Sort.abcBy("name"));
        this.processGroupsD365 = success.data.d365ProcessGroups
          .sort(this.Sort.abcBy("name"))
          .map(pgD365 => {
            pgD365.info = pgD365.name;
            return pgD365;
          });

        this.mapperToDisplay = this.processGroupsKlix && this.processGroupsKlix.map(pgKlix => {
          
          return {
            processGroupName: pgKlix.name,
            processGroupId: pgKlix.id,
            d365ProcessGroupName: pgKlix.d365ProcessGroupName,
            d365Active: pgKlix.d365Active,
            unmatched: !pgKlix.d365ProcessGroupName
          };
        });

        this.state = "loaded";
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  editMatch(entity) {
    this.processMatch = {info: entity.d365ProcessGroupName, name: entity.d365ProcessGroupName};
    this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
  }

  cancel() {
    this.processMatch = null;
    this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
  }

  saveEdit(pg, d365ProcessToMatch) {
    this.state = "loading";

    this.D365.savePGPGMapper(
      pg.processGroupId,
      angular.fromJson(d365ProcessToMatch).name,
      angular.fromJson(d365ProcessToMatch).hierarchyId,
      angular.fromJson(d365ProcessToMatch).description
    ).then(
      () => {
        this.processMatch = null;
        this.getData();
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  viewProcesses(mapper) {
    this.$location.path('/d365/processGroups/'+ mapper.processGroupId + '/name/' + mapper.processGroupName);
  }

  deleteMatch(mapper) {
    this.state = "loading";
    this.D365.deletePGPGMapper(mapper.processGroupId).then(
      () => {
        this.getData();
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }
}